import {
    MDBAlert,
    MDBAutocomplete,
    MDBBadge,
    MDBBtn,
    MDBCheckbox,
    MDBIcon,
    MDBInput,
    MDBListGroup,
    MDBListGroupItem,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBSpinner,
    MDBTable,
    MDBTableBody,
    MDBTableHead,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { PurchasePHNumber, getMisc, getPurchasePhoneNumbers, sendRequestTnRelase, sendRequestTnReserve } from "../../apiclients/streamsapi_bridge";
import { formattedNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
import ReqSMSPhNums from "../../views/popups/phonenumbers/ReqSMSPhNums";
import PopupLoader from "../../views/popups/PopupLoader";
import AddNewPhoneNumberSearch from "./AddNewPhoneNumberSearch";
import PurchasePopupTabs from "./PurchasePopupTabs";
import TolllFreePurchasePopupTabs from "./TolllFreePurchasePopupTabs";
import { Tooltip } from "react-tooltip";
import PurchaseResultsDialog from "../../views/popups/PurchaseResultsDialog";

const customDefData = [
    {
        title: (<>
            Harish<MDBBadge color="primary" title="SMS Capable" className="fw-400"><MDBIcon far icon="comment-alt" /></MDBBadge>
        </>), subtitle: 'State Name'
    },
    { title: 'Two', subtitle: 'Secondary text' },
    { title: 'Three', subtitle: 'Secondary text' },
    { title: 'Four', subtitle: 'Secondary text' },
    { title: 'Five', subtitle: 'Secondary text' },
    { title: 'Six', subtitle: 'Secondary text' },
];
const customDefData2 = [
    { title: 'One', subtitle: 'Secondary text' },
    { title: 'Two', subtitle: 'Secondary text' },
    { title: 'Three', subtitle: 'Secondary text' },
    { title: 'Four', subtitle: 'Secondary text' },
    { title: 'Five', subtitle: 'Secondary text' },
    { title: 'Six', subtitle: 'Secondary text' },
];
const customDefData3 = [
    { title: 'One', subtitle: 'Secondary text' },
    { title: 'Two', subtitle: 'Secondary text' },
    { title: 'Three', subtitle: 'Secondary text' },
    { title: 'Four', subtitle: 'Secondary text' },
    { title: 'Five', subtitle: 'Secondary text' },
    { title: 'Six', subtitle: 'Secondary text' },
];

export default function Purchase(props) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [phonestates, setPhoneStates] = useState([]);
    const [billinggrps, setBillinggrps] = useState([]);


    const [nxx, setNxx] = useState([]);
    const [errors, setErrors] = useState([]);
    const { t, i18n } = useTranslation();
    const selectCodeRef = React.useRef(null);
    const navigate = useNavigate();
    const [statecode, setStatecode] = useState([]);
    const [stateCodeDisplay, setStateCodeDisplay] = useState([]);
    const [selectAreaCode, setSelectAreaCode] = useState(null);
    const [areaCode, setAreaCode] = useState(null);
    const [selectedStateCode, setSelectedStateCode] = useState(0);
    const [tollFreeAreaCodes, settollFreeAreaCodes] = useState([]);
    const [tollFreeAreaCodesDisplay, settollFreeAreaCodesDisplay] = useState([]);
    const [selectTollFreeAreaCode, setselectTollFreeAreaCode] = useState(-1);
    const [numberList, setnumberList] = useState([]);
    const [tollFreeNumList, settollFreeNumList] = useState([]);
    const [addPurchase, setAddPurchase] = useState([]);
    const [deleteCheckedNum, setdeleteCheckedNum] = useState([]);
    const [globalDelete, setGlobalDelete] = useState(false);
    const [globalDeleteChecked, setGlobalDeleteChecked] = useState(false);
    const [advancedNumbers, setAdvancedNumbers] = useState([]);
    const [tollAdvancedNumber, setTollAdvancedNumbers] = useState([]);
    const [patternNumbers, setpatternNumbers] = useState([]);
    const [tollVanityNumbers, settollVanityNumbers] = useState([]);
    const [tollPatternNumbers, settollPatternNumbers] = useState([]);
    const [searchType, setsearchType] = useState(0);
    const [disableMainSearch, setDisableMainSearch] = useState(false);
    const [advacedSearchType, setAdvacedSearchType] = useState("");
    const [locations, setLocations] = useState([]);
    const [selectLocation, setSelectLocation] = useState(-1);
    const [purchaseselectLocation, setPurchaseSelectLocation] = useState(-1);
    const [tollFreeError, setTollFreeError] = useState([]);
    const [NormalError, setNormalError] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [billinggrpid, setbillinggrpid] = useState(1);
    const [addPurchaseError, setAddPPurchaseError] = useState("")
    const [existAreaCode, setexistAreaCode] = useState(-1);
    const [exitingTollFreeAreaCode, setexitingTollFreeAreaCode] = useState(-1);
    const [callerIdName, setCallerIdName] = useState("");
    const [successNumbers,setSuccessNumbers] = useState();
    const [failedNumbers,setFailedNumbers] = useState();
    const [showFailedPopup,setShowFailedPopup] = useState(false);
    const [failedTnReserved,setFailedTnReserved] = useState();

   const unsavedWarningToggle = async () => {
        setAddPPurchaseError("")
        setSuccessNumbers([]);
        setFailedNumbers([]);
        props.onClose();
    };
    const handleUnsavedOk = async () => {
        setAddPPurchaseError("");
        setSuccessNumbers([]);
        setFailedNumbers([]);
        props.onClose();
    }
    const searchAreaCode = (value) =>
        setStateCodeDisplay(statecode.filter((item) => (item.area_code + "").toLowerCase().startsWith((value + "").toLowerCase())));

    const searchTollFreeCode = (value) =>
        settollFreeAreaCodesDisplay(tollFreeAreaCodes.filter((item) => (item.area_code + "").toLowerCase().startsWith((value + "").toLowerCase())));

    const [centredModal, setCentredModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const [selectedPreviewNumber, setselectedPreviewNumber] = useState(false);
    const toggleSelected = () => setselectedPreviewNumber(!selectedPreviewNumber);
    const [submitFlag, setSubmitFlag] = useState(false);
    const [submitTollFlag, setSubmitTollFlag] = useState(false);
    const [fillActive, setFillActive] = useState('tab1');

    const handleFillClick = (value) => {
        if (value === fillActive) {
            return;
        }

        setFillActive(value);
        fetchDefualtData(value);
        setTollAdvancedNumbers([]);
        setAdvancedNumbers([]);
        setsearchType(0)
    };

    const [Page, setPage] = useState(1);
    console.log(Page)

    useEffect(() => {
        if (props.isActive) {
            setFillActive("tab1")
            setAddPurchase([]);
            setPage(1);
            fetchDefualtData(fillActive);
            fetchLocations();
            fetchAllBillingGroups();
            setShowAdvancedSearch(false);
        }
    }, [props.isActive])


    async function fetchDefualtData(fillActive) {
        console.log(sessionStorage.getItem("admin_session"));
        setIsloading(true);
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["add_phone_numbers"], tab: fillActive }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
        }

        setStatecode(tdata?.misc?.add_phone_numbers?.area_codes ?? []);
        setStateCodeDisplay(tdata?.misc?.add_phone_numbers?.area_codes ?? []);
        setSelectAreaCode(tdata?.misc?.add_phone_numbers?.area_code ?? -1);
        setAreaCode(tdata?.misc?.add_phone_numbers?.area_code ?? -1)
        setexistAreaCode(tdata?.misc?.add_phone_numbers?.area_code ?? -1);
        settollFreeAreaCodes(tdata?.misc?.add_phone_numbers?.tollfree_area_codes ?? []);
        settollFreeAreaCodesDisplay(tdata?.misc?.add_phone_numbers?.tollfree_area_codes ?? []);
        setselectTollFreeAreaCode(tdata?.misc?.add_phone_numbers?.tollfree_area_code ?? -1);
        setexitingTollFreeAreaCode(tdata?.misc?.add_phone_numbers?.tollfree_area_code ?? -1);
        setnumberList(tdata?.misc?.add_phone_numbers?.phone_numbers ?? []);
        settollFreeNumList(tdata?.misc?.add_phone_numbers?.tollfree_phone_numbers ?? []);
        setIsloading(false);
    }


    useEffect(() => { // Setting the stateCode for it.
        if ((selectAreaCode != -1 && fillActive === 'tab1')) {
            setSelectedStateCode(statecode.filter(obj => obj.area_code == selectAreaCode)?.[0]?.state_code ?? 0);
        } else if (selectTollFreeAreaCode && fillActive === 'tab2') {
            setSelectedStateCode(tollFreeAreaCodes.filter(obj => obj.area_code == selectTollFreeAreaCode)?.[0]?.state_code ?? 0);
        }

    }, [selectAreaCode, selectTollFreeAreaCode]);


    async function fetchLocations() {
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["all_locations"] }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
        }
        const locationList = tdata?.misc?.all_locations ?? [];
        setLocations(locationList);
        const defaultLocationJSON = locationList.find(location => location.default_loc);
        console.log("default location :::::::" + JSON.stringify(defaultLocationJSON));
        if (defaultLocationJSON) {
            setSelectLocation(defaultLocationJSON.loc_id ?? -1);
            setPurchaseSelectLocation(defaultLocationJSON.loc_id ?? -1);
        }

    }

    async function fetchAllBillingGroups() {
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["billinggroups"] }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
        }
        const billingGroup = tdata?.misc?.billinggroups ?? [];
        setBillinggrps(billingGroup);
    }





    function fetchPhoneNumbers(stateCode) {
        let updates = {
            reqid: 66,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            area_code: stateCode
        }
        fetchRequiredPhoneNumbers(updates, 1)

    }

    function fetchtollPhoneNumbers(stateCode) {
        let updates = {
            reqid: 66,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            area_code: stateCode,
            is_tollfree: true
        }
        fetchRequiredPhoneNumbers(updates, 2)

    }

    /**
     * 
     * @param {*} updates
     * 1. local phone numbers when area code change
     * 2. toll free phone numbers when area code changes
     * 3. vanity search result for local
     * 4. vanity search result for toll free
     * 5. pattern search for local
     * 6. pattern search for toll free
     * 7. location Search for local
     * @returns 
     */

    async function fetchRequiredPhoneNumbers(updates, flag) {
        setIsloading(true);
        setsearchType(flag);
        setNormalError([]);
        setTollFreeError([]);
        if (updates.pattern) {
            setAdvacedSearchType(updates.pattern);

        } else if (updates.vanity) {
            setAdvacedSearchType(updates.vanity);
        }
        let saverep = await getPurchasePhoneNumbers(updates);
        if (!saverep.json) {
            const message = `An error has occured: ${saverep.statusText}`;
            return;
        }
        const tdata = await saverep.json();
        console.log("Phone Numbers  ::::::::: " + JSON.stringify(tdata));

        if (!tdata) {
            window.alert(`info with id  not found`);
        }

        if (tdata.status && tdata.status === "success") {
            switch (flag) {
                case 1:
                    setnumberList(tdata?.phone_numbers ?? []);
                    break;
                case 2:
                    settollFreeNumList(tdata?.phone_numbers ?? []);
                    break;
                case 3:
                    setAdvancedNumbers(tdata?.vanity_numbers ?? []);
                    break;
                case 5:
                    setAdvancedNumbers(tdata?.pattern_numbers ?? []);
                    break;
                case 4:
                    setTollAdvancedNumbers(tdata?.vanity_tollfree_numbers ?? []);
                    break;
                case 6:
                    setTollAdvancedNumbers(tdata?.pattern_numbers ?? []);
                    break;
                case 7:
                    setAdvancedNumbers(tdata?.location_numbers ?? []);
                    break;
                default:
                    break;
            }
        } else {
            let errorList = [];

            if (tdata.message?.errors) {
                tdata.message.errors.forEach((err) => {
                    const error = {
                        fieldname: err.param_name,
                        message: err.message,
                    }
                    errorList.push(error);

                });
            }
            switch (flag) {
                case 1:
                    setnumberList([]);
                    break;
                case 2:
                    settollFreeNumList([]);
                    break;
                case 3:
                case 5:
                case 7:
                    setNormalError(errorList)

                    setAdvancedNumbers([]);
                    break;
                case 4:
                case 6:
                    setTollFreeError(errorList);
                    setTollAdvancedNumbers([]);
                    break;
                default:
                    break;


            }

        }
        if (flag === 4 || flag === 6) {
            setSubmitTollFlag(true);

        } else if (flag === 3 || flag === 5 || flag === 7) {
            setSubmitFlag(true);
        }
        setIsloading(false);

    }

    async function handleRemove(e, removeList) {
        console.log("handleRemove :::::::: removeList ::: " + removeList);
        e.preventDefault();
        const updateList = addPurchase.filter(item => !removeList.includes(item.phone_number));
        setAddPurchase(updateList);
        let tnReleaseParams = [
            {
                phone_number: removeList[0],
            }]
        let tnReleaseInfo = await sendRequestTnRelase(tnReleaseParams);
        let responseData = await tnReleaseInfo.json();
        console.log("responseData ::: " + JSON.stringify(responseData))
    }



    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

    const toggleAdvancedSearch = () => {
        setShowAdvancedSearch(!showAdvancedSearch);
    };
    const [showTollAdvancedSearch, setShowTollAdvancedSearch] = useState(false);

    const toggleTollAdvancedSearch = () => {
        setShowTollAdvancedSearch(!showTollAdvancedSearch);
    };

    async function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log("Errors :::: ", JSON.stringify(errors))
        const err = errors.filter((item) => item !== "");

        if (err.length > 0) return

        const purchasephNumbers = addPurchase.map(number => number.phone_number);
        console.log("addPurchase ::::: " + JSON.stringify(addPurchase))
        const updates = {
            reqid: 13,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            location_id: parseInt(purchaseselectLocation),
            billing_grp: parseInt(billinggrpid),
            purchase_phone_numbers: addPurchase.filter(obj => obj.api == false).map(obj => ({ "phone_number": obj.phone_number, "callerid_name": obj.callerid_name })),
            inteliquent_phone_numbers: addPurchase.filter(obj => obj.api == true).map(obj => (
                {
                    "phone_number": obj.phone_number, "is_toll_free": obj.is_toll_free, "province": obj.province,
                    "lata": obj.lata, "loginusername": JSON.parse(sessionStorage.getItem("admin_session")).loginusername,
                    "callerid_name": obj.callerid_name
                }))
        };
        console.log("purchase Phone Number ::::: " + JSON.stringify(updates));
        setIsloading(true);
        let saverep = await PurchasePHNumber(updates);
        setTimeout(() => { setIsloading(false) }, 1000);
        console.log("response :::::::::::" + saverep);
        var saverepeMsg = await saverep.json();
        console.log("reponse json ::::: " + JSON.stringify(saverepeMsg));
        console.log("status :::" + saverep?.status)
        if (!saverep.ok) {
            if (saverep?.status == 500) {
                localStorage.setItem("f_message", "Internal Server Error");
                window.location.href = "/phonenumbers";
                if (saverepeMsg.inteliquentStatus != 200 && saverepeMsg.exclude_tn.length >= 0) {
                    let result = `${t("InteliquentPurchesePhNumersExistMessage")} <br/> <b>${saverepeMsg.exclude_tn.join(", ")}</b>`;
                    setAddPPurchaseError(result);
                }
            } else {
                localStorage.setItem("f_message", "Internal Server Error");
                window.location.href = "/phonenumbers";
            }
        } else {
            let message = "";
            let successMsg;
            let failureMsg;
            if (saverepeMsg?.inteliquentStatus != 200 && saverepeMsg?.exclude_tn?.length > 0) {
                if (saverepeMsg.inteliquentStatus == 432 || saverepeMsg.inteliquentStatus == 425) {
                    successMsg = saverepeMsg?.phNums && saverepeMsg?.phNums?.length > 0
                        ? `${t("InteliquentPurchesePhNumersExistSucess")} <br/> <b>${saverepeMsg.phNums.join(", ")}</b>`
                        : "";
                    failureMsg = saverepeMsg?.exclude_tn?.length > 0 ?
                        `${t("InteliquentPurchesePhNumersExistMessage")} <br/> <b>${saverepeMsg.exclude_tn.join(", ")}</b>`
                        : "";
                }
                message = `${successMsg}${successMsg && failureMsg ? "<br/><br/>" : ""}${failureMsg}`;
                setAddPPurchaseError(message);
                setSuccessNumbers(saverepeMsg?.phNums);
                setFailedNumbers(saverepeMsg?.exclude_tn); 
                return;
            }
            localStorage.setItem("s_message", "Phone Number purchased successfully.");
            setAddPurchase([]);
            setPage(1);
            // props.setSuccessMessage("Phone Number purchased successfully");
            props.setRerenderFlag(true);
            props.onClose();
            sessionStorage.setItem("activeTab", "tab2");
            window.location.href = "/phonenumbers";
        }
    }
    async function handleNextPage() {
        console.log("handleNextPage We are reserving Phone Numbers addPurchase  " + JSON.stringify(addPurchase));
        let tnReserveList = addPurchase.filter(obj => obj.api == true && obj.is_toll_free == false).map(obj => (
            {
                "phone_number": obj.phone_number, "is_toll_free": obj.is_toll_free, "province": obj.province,
                "lata": obj.lata, "loginusername": JSON.parse(sessionStorage.getItem("admin_session")).loginusername,
                "callerid_name": obj.callerid_name, "tnReserve": false
            }));
        console.log("tnReserveList :::: " + JSON.stringify(tnReserveList));
        setIsloading(true);
        let responseInfo = await sendRequestTnReserve(tnReserveList);
        let responseData = await responseInfo.json();
        console.log("responseData ::: " + JSON.stringify(responseData));
     if (responseData?.status == "Success" && responseData?.statusCode == "200") {
    const excludedList = responseData?.tnReserveResponse?.excludedTnList || [];
    console.log("excludedList ::: " + excludedList)

    // ✅ Case 1: Some numbers failed
    if (excludedList.length > 0) {
        let failedNumbers = excludedList?.map(item => item.tn);

        const updatedList = addPurchase.filter(item =>
            !failedNumbers.some(failed =>
                item.phone_number.replace(/^1/, '') == failed)
        ).map(item => ({ ...item, tnReserve: true }));

        let finalNumbersList = numberList.filter(item =>
            !failedNumbers.some(failed =>
                item.phone_number.replace(/^1/, '') == failed
            )
        );

        setnumberList(finalNumbersList);
        setAddPurchase(updatedList);

        setShowFailedPopup(true);
        setFailedTnReserved(failedNumbers)
    }

    // ✅ Case 2: All numbers success (JUST ADD THIS)
    if (excludedList.length == 0) {
        console.log("updatedList ::::::::");
        const updatedList = addPurchase.map(item => ({
            ...item,
            tnReserve: true
        }));
        setAddPurchase(updatedList);
        console.log("updatedList ::: " + JSON.stringify(updatedList))
    }
} 
        if(!showFailedPopup){
            const nextPage = Page + 1;
            setPage(nextPage);
        }
    
        setIsloading(false);
    }

    const validateCallerIdName = (value, index) => {
        let err = "";

        if (value.trim() === "") {
            err = "";
        } else if (!/^[A-Za-z0-9.,&\-_' ]+$/.test(value)) {
            err = "Invalid characters";
        } else if (/^\d+$/.test(value)) {
            err = "Must contain at least one letter";
        } else if (value.length > 15) {
            err = "Maximum 15 characters allowed";
        } else if (!/[A-Za-z]/.test(value)) {
            err = "Must contain at least one letter";
        } else if (value.length < 2) {
            err = "Minimum 2 characters required";
        }

       
        setErrors(prev => {
            const arr = [...prev];

            while (arr.length <= index) {
                arr.push("");
            }

            arr[index] = err;
            return arr;
        });


        return err === "";
    };

          const handleClose = () => {
            setShowFailedPopup(false);

            if (addPurchase.length == 0) {
              window.location.href = "/phonenumbers";
            }
          };

    const updateCallerId = (index, value) => {
        validateCallerIdName(value, index);
        console.log("updateCallerId value " + value)
        setAddPurchase(prev => {
            const arr = [...prev];
            arr[index].callerid_name = value;
            console.log("callerid added values  " + JSON.stringify(arr))
            return arr;
        });
    };
    const [SMSenabledphonenumbers, setSMSenabledphonenumbers] = useState(false);

    const SmsReqtoggleOpen = () => setSMSenabledphonenumbers(!SMSenabledphonenumbers);

    return (
        <>
            <div>
                {
                    Page == 1 ? <>
                        <div>
                            {/* <h4>Add Phone Numbers</h4> */}

                            <div>
                                {/* <div>
                                    <label>{t("Select Region")} <span className="red">*</span></label>
                                    <div className="form width-100">
                                        <div className="phoneselect">
                                            <select className="form-control form-select  selectname">
                                                <option value="-1">United States</option>
                                                <option value="0">Canada</option>
                                            </select>
                                        </div> 
                                    </div>
                                </div> */}
                                <MDBTabs fill className='my-4'>
                                    <MDBTabsItem>
                                        <MDBTabsLink onClick={() => handleFillClick('tab1')} active={fillActive === 'tab1'}>
                                            {t("Local Numbers")}
                                        </MDBTabsLink>
                                    </MDBTabsItem>
                                    <MDBTabsItem>
                                        <MDBTabsLink onClick={() => handleFillClick('tab2')} active={fillActive === 'tab2'}>
                                            {t("Toll-Free Numbers")}
                                        </MDBTabsLink>
                                    </MDBTabsItem>
                                </MDBTabs>

                                <MDBTabsContent>
                                    <MDBTabsPane open={fillActive === 'tab1'}>
                                        <div className="col-lg-12 mt-4">
                                            {/* <label>{t("Local Numbers")} <span className="red">*</span></label> */}
                                            {!showAdvancedSearch && (
                                                <>
                                                    <div className="d-flex">
                                                        <div className="w-20 me-2">
                                                            <MDBAutocomplete
                                                                disabled={disableMainSearch}
                                                                data={stateCodeDisplay}
                                                                label="Area Code"
                                                                displayValue={(row) => row.area_code}
                                                                value={selectAreaCode}
                                                                onSearch={searchAreaCode}
                                                                onSelect={fetchPhoneNumbers}
                                                                onChange={(value) => {
                                                                    setSelectAreaCode(value);

                                                                }}
                                                                itemContent={(result) => (
                                                                    <div className='autocomplete-custom-item-content' onChange={(e) => fetchPhoneNumbers(e, result.area_code)}>
                                                                        <div className='autocomplete-custom-item-title'>{result.area_code} {result.did_availability > 0 && ('*')}</div>
                                                                        <div className='small'>{result.state_name}</div>
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                        <div className="w-80">
                                                            <AddNewPhoneNumberSearch
                                                                numberList={numberList}
                                                                PurchaseNum={setAddPurchase}
                                                                addedNumber={addPurchase}
                                                                isTollfree={false}
                                                                disableMainSearch={disableMainSearch}
                                                                open={false}
                                                            />
                                                        </div>
                                                    </div>
                                                    {numberList && numberList?.length == 0 && (
                                                        <div className="w-100 border border-2 p-4 py-5 mt-2 rounded-2 d-flex align-items-center justify-content-center flex-column shadow-2 bg-secondary bg-opacity-10">
                                                            <MDBIcon fas icon="search" className="fs-1" color="secondary" />
                                                            <h4>No numbers found</h4>
                                                            <p className="fw-bold ">
                                                                Please{" "}
                                                                <a href="#" className="fw-500 cursor-pointer" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    SmsReqtoggleOpen();
                                                                }}
                                                                >
                                                                    click here
                                                                </a>{" "}
                                                                to request for SMS enabled phone numbers
                                                            </p>
                                                        </div>
                                                    )
                                                    }


                                                    <div className="text-end my-4">
                                                        <MDBBtn color="secondary" className="fw-600 link" onClick={toggleAdvancedSearch}>
                                                            Advanced search
                                                        </MDBBtn>
                                                    </div>


                                                </>
                                            )}
                                        </div>

                                        {/* <div className="mt-2 ">
                                            <div className="border rounded-3 accordion-headerCustom">
                                                <MDBAccordion borderless className="p-0 ">
                                                    <MDBAccordionItem collapseId={1} onClick={(e) => {
                                                        e.preventDefault();
                                                        setDisableMainSearch(obj => !obj);
                                                    }} headerTitle='Advanced Search'> */}

                                        {showAdvancedSearch && (
                                            <div className="mt-2 bg-light p-3 border">
                                                <PurchasePopupTabs
                                                    oSubmit={fetchRequiredPhoneNumbers}
                                                    areacode={selectAreaCode}
                                                    setSelectAreaCode={setSelectAreaCode}
                                                    defultAreaCode={areaCode}
                                                    setTollAdvancedNumbers={setTollAdvancedNumbers}
                                                    setAdvancedNumbers={setAdvancedNumbers}
                                                    setsearchType={setsearchType}
                                                    stateCodeDisplay={statecode}
                                                    locations={locations}
                                                    toggleAdvancedSearch={toggleAdvancedSearch}
                                                    searchType={searchType}
                                                    advancedNumbers={advancedNumbers}
                                                    addPurchase={addPurchase}
                                                    setAddPurchase={setAddPurchase}
                                                    advacedSearchType={advacedSearchType}
                                                    selectLocation={selectLocation}
                                                    setSelectLocation={setSelectLocation}
                                                    errorList={NormalError}
                                                    setSubmitFlag={setSubmitFlag}
                                                    submitFlag={submitFlag}
                                                    existAreaCode={existAreaCode}
                                                // vanityNumbers={advancedNumbers}
                                                // patternNumbers={patternNumbers}
                                                />
                                            </div>
                                        )}
                                        {/* </MDBAccordionItem>
                                                </MDBAccordion>
                                            </div>
                                        </div> */}

                                    </MDBTabsPane>
                                    <MDBTabsPane open={fillActive === 'tab2'}>


                                        <div className="col-lg-12 mt-4">
                                            {!showTollAdvancedSearch && (
                                                <>
                                                    {/* <label>{t("Toll-Free Numbers")} <span className="red">*</span></label> */}
                                                    <div className="d-flex">
                                                        <div className="w-20 me-2">
                                                            <MDBAutocomplete
                                                                data={tollFreeAreaCodesDisplay}
                                                                label="Area Code"
                                                                displayValue={(row) => row.area_code}
                                                                value={selectTollFreeAreaCode}
                                                                onSelect={fetchtollPhoneNumbers}
                                                                onSearch={searchTollFreeCode}
                                                                onChange={(value) => {
                                                                    setselectTollFreeAreaCode(value);
                                                                }}
                                                                itemContent={(result) => (
                                                                    <div className='autocomplete-custom-item-content text-dark'>
                                                                        <div className='autocomplete-custom-item-title'>{result.area_code} {result.did_availability > 0 && ('*')}</div>
                                                                        <div className='small'>{result.state_name}</div>
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                        <div className="w-80">
                                                            <AddNewPhoneNumberSearch
                                                                numberList={tollFreeNumList}
                                                                PurchaseNum={setAddPurchase}
                                                                addedNumber={addPurchase}
                                                                isTollfree={true}
                                                            />
                                                        </div>
                                                    </div>
                                                    {tollFreeNumList && tollFreeNumList?.length == 0 && (
                                                        <div className="w-100 border border-2 p-4 py-5 mt-2 rounded-2 d-flex align-items-center justify-content-center flex-column shadow-2 bg-secondary bg-opacity-10">
                                                            <MDBIcon fas icon="search" className="fs-1" color="secondary" />
                                                            <h4>No numbers found</h4>
                                                            <p className="fw-bold">
                                                                Please{" "}
                                                                <a href="#" className="fw-500 cursor-pointer" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    SmsReqtoggleOpen();
                                                                }}
                                                                >
                                                                    click here
                                                                </a>{" "}
                                                                to request for SMS enabled phone numbers
                                                            </p>
                                                        </div>
                                                    )}
                                                    <div className="text-end my-4">
                                                        <MDBBtn color="secondary" className="fw-600 link" onClick={toggleTollAdvancedSearch}>
                                                            Advanced search
                                                        </MDBBtn>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {/* <div className="mt-2 ">
                                            <div className="border rounded-3 accordion-headerCustom">
                                                <div className="mt-2 bg-light p-3 border"> */}
                                        {showTollAdvancedSearch && (
                                            <div className="mt-2 bg-light p-3 border">
                                                <TolllFreePurchasePopupTabs
                                                    oSubmit={fetchRequiredPhoneNumbers}
                                                    areacode={selectTollFreeAreaCode}
                                                    setTollAdvancedNumbers={setTollAdvancedNumbers}
                                                    setAdvancedNumbers={setAdvancedNumbers}
                                                    setsearchType={setsearchType}
                                                    tollFreeAreaCodesDisplay={tollFreeAreaCodes}
                                                    toggleAdvancedSearch={toggleTollAdvancedSearch}
                                                    searchType={searchType}
                                                    tollAdvancedNumber={tollAdvancedNumber}
                                                    addPurchase={addPurchase}
                                                    setAddPurchase={setAddPurchase}
                                                    advacedSearchType={advacedSearchType}
                                                    errorList={tollFreeError}
                                                    setSubmitFlag={setSubmitTollFlag}
                                                    submitFlag={submitTollFlag}
                                                    exitingTollFreeAreaCode={exitingTollFreeAreaCode}
                                                />
                                            </div>
                                        )}

                                        {/* </div>
                                            </div>
                                        </div> */}
                                    </MDBTabsPane>
                                </MDBTabsContent>

                            </div >
                        </div>
                    </> : Page == 2 ? <>
                        <div>
                            <div>
                                <h4 className="m-0 fw-bold">Confirm</h4>


                            </div>
                            <div className="border rounded-2 p-3">
                                <div className="row pb-2 mt-2">
                                    <div className="col-6">
                                        <div className="tel-numbers">
                                            <strong>{t("location")}</strong>
                                        </div>
                                        <select
                                            className="form-select form-control w-100"
                                            name="San Jose"
                                            value={purchaseselectLocation}
                                            onChange={(e) => setPurchaseSelectLocation(e.target.value)}
                                        >
                                            {locations && locations.length > 0 && locations.map((loc) => (
                                                <option value={loc.loc_id}>{loc.address}</option>

                                            ))}

                                        </select>
                                    </div>


                                    <div className="col-6">
                                        <div className="tel-numbers">
                                            <strong>{t("billingGroup")}</strong>
                                        </div>
                                        <select
                                            className="form-select form-control w-100"
                                            name="San Jose"
                                            value={billinggrpid}
                                            onChange={(e) => setbillinggrpid(e.target.value)}
                                        >
                                            {billinggrps && billinggrps.length > 0 && billinggrps.map((group) => (
                                                <option value={group.groupid}>{group.groupname}</option>
                                            ))}

                                        </select>

                                    </div>
                                </div>
                                <div className=" mt-2 bg-info bg-opacity-10 rounded-3 p-2" style={{ fontSize: "10px" }}>
                                    <span className="fw-bold" style={{ fontSize: "10px" }}>{t("Note")}:</span> {t("confirmationNote")}
                                </div>

                            </div>
                            <div className=" mt-3 mb-2">
                                <h4 className="m-0"  >
                                    Your Number(s) and Caller ID Name
                                </h4>
                                <p style={{ fontSize: '14px' }}>
                                    Confirm these are the numbers you want. You can remove numbers here or click on <b>Previous</b> to add more numbers.
                                </p>
                            </div>
                            <div className="table-responsive border border-1 rounded-top">
                                <div className="localtable-wrapper-scroll-y my-localcustom-scrollbar">
                                    <MDBTable className="mb-0">
                                        <MDBTableHead>
                                            <tr>
                                                <th scope='col'>
                                                    <div className='d-flex justify-content-between align-items-center pt-2 ps-3 pe-4'>
                                                        <div className="d-flex align-items-center">
                                                            <MDBCheckbox
                                                                className="me-3"
                                                                checked={globalDeleteChecked}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        const update = addPurchase.map(item => item.phone_number);
                                                                        setdeleteCheckedNum(update);
                                                                    } else {
                                                                        setdeleteCheckedNum([]);
                                                                    }
                                                                    setGlobalDelete(e.target.checked);
                                                                    setGlobalDeleteChecked(e.target.checked);
                                                                    toggleSelected();
                                                                }}
                                                            />
                                                            {selectedPreviewNumber ? (
                                                                <div className='fw-bold ms-2 text-primary'>{`${addPurchase.length}/${addPurchase.length} Selected`}</div>
                                                            ) : (
                                                                <div className='fw-bold ms-2'>{`${addPurchase.length} Number(s)`}</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </th>
                                                <th scope='col'>
                                                    <div>
                                                        <h6 className="m-0">Caller ID Name <MDBIcon fas icon="info-circle ms-2 callerinfo" /></h6>
                                                        <p style={{ fontSize: "10px" }}>Updating the Caller ID Name may take 7–14 business days.</p>
                                                    </div>
                                                </th>
                                                <th scope="col" align="center">
                                                    {globalDelete && (
                                                        <MDBIcon fas icon="close" onClick={(e) => handleRemove(e, deleteCheckedNum)} color="primary" />
                                                    )}
                                                </th>

                                            </tr>
                                        </MDBTableHead>
                                        <MDBTableBody>
                                            {addPurchase.length > 0 && addPurchase.map((number, index) => (
                                                <tr key={index} className="callerid_row">
                                                    <td scope="row">
                                                        <MDBListGroup light className="list-view ps-3 py-0">
                                                            <MDBListGroupItem className='d-flex justify-content-between align-items-center border-0'>
                                                                <div className="d-flex align-items-center">
                                                                    <MDBCheckbox
                                                                        className="me-3"
                                                                        checked={(deleteCheckedNum.includes(number.phone_number))}
                                                                        onChange={(e) => {
                                                                            let updateDelete = [];
                                                                            if (e.target.checked) {
                                                                                updateDelete = [...deleteCheckedNum, number.phone_number];
                                                                                setGlobalDelete(true);

                                                                            } else {
                                                                                updateDelete = deleteCheckedNum.filter(num => num !== number.phone_number);
                                                                                setGlobalDeleteChecked(false);
                                                                            }
                                                                            setdeleteCheckedNum(updateDelete);
                                                                            if (addPurchase.length === updateDelete.length) {
                                                                                setGlobalDeleteChecked(true);
                                                                            }
                                                                            if (updateDelete.length === 0) {
                                                                                setGlobalDelete(false);
                                                                            }
                                                                        }
                                                                        }
                                                                    />
                                                                    <div>
                                                                        <div className="d-flex align-items-center ms-2">
                                                                            <div className='me-2 d-flex align-items-center'>{formattedNumber(number.phone_number)}
                                                                                {number.is_sms_enabled === 1 && (
                                                                                    <MDBBadge color="primary" title="SMS Capable" className="fw-400 ms-2">
                                                                                        <MDBIcon far icon="comment-alt" />
                                                                                    </MDBBadge>

                                                                                )}
                                                                                {number.is_toll_free ? (
                                                                                    <MDBBadge pill light color='warning' className="ms-2">Toll-free</MDBBadge>
                                                                                ) : (
                                                                                    <MDBBadge pill light color='primary' className="ms-2">Local</MDBBadge>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </MDBListGroupItem>

                                                        </MDBListGroup>
                                                    </td>
                                                    <td scope="row">
                                                        <input type="text"
                                                            class="form-control"
                                                            placeholder="Caller ID Name"
                                                            onChange={(e) => updateCallerId(index, e.target.value)} />
                                                        {errors[index] && (
                                                            <small className="text-danger">{errors[index]}</small>
                                                        )}
                                                    </td>
                                                    <td scope="row" align="center">
                                                        {!deleteCheckedNum.includes(number.phone_number) && (
                                                            <div class="d-flex align-items-center justify-content-center">
                                                                <div class="custom-hover-bg p-1 cursor-pointer removetotip">
                                                                    <MDBIcon fas icon="close" onClick={(e) => handleRemove(e, [number.phone_number])} color="primary" />
                                                                </div>
                                                            </div>

                                                        )}
                                                    </td>

                                                </tr>
                                            ))}
                                        </MDBTableBody>
                                    </MDBTable>
                                </div>
                            </div>
                            <div className="border p-2 rounded-bottom border-top-0">
                                <div className="bg-info bg-opacity-10 rounded-3 p-2" style={{ fontSize: "10px" }}>
                                    <span className="fw-bold" style={{ fontSize: "10px" }}>{t("Note")}:</span> {t("PurchasephNumbersNote")}
                                </div>
                            </div>
                        </div>
                    </> : null
                }
            </div>
            {addPurchase.length > 0 && (<>
                <MDBModalFooter className="mt-2">
                    {/* <MDBBtn color='secondary'>
                    Save to Draft
                </MDBBtn> */}
                    <div className="text-end">
                        {
                            Page < 2 &&
                            <MDBBtn color='secondary' onClick={(e) => props.onClose(e)}>
                                Cancel
                            </MDBBtn>
                        }
                        {
                            Page < 2 ? (
                                <MDBBtn onClick={handleNextPage} className="ms-2">
                                    Next
                                </MDBBtn>
                            ) : (
                                <>

                                    <MDBBtn color='secondary' onClick={() => {
                                        const nextPage = Page - 1;
                                        setPage(nextPage);
                                    }}>
                                        Previous
                                    </MDBBtn>
                                    <MDBBtn className="ms-2" onClick={handleSubmit}>
                                        Order
                                    </MDBBtn>
                                </>
                            )
                        }
                    </div>
                </MDBModalFooter>
            </>)}
             {(successNumbers?.length > 0 || failedNumbers?.length > 0) && (
                <PopupLoader
                    size="md"
                    className="modal-md"
                    title="Phone Number Purchase Summary"
                    onClose={handleUnsavedOk}
                    content={
                        <>
                            <PurchaseResultsDialog
                                successNumbers={successNumbers}
                                failedNumbers={failedNumbers}
                                onOk={handleUnsavedOk}
                            />

                            <div className="modal-footer border-0">
                                <MDBBtn color="primary" onClick={handleUnsavedOk}>
                                    OK
                                </MDBBtn>
                            </div>
                        </>
                    }
                />
            )}
            {showFailedPopup && (
                <PopupLoader
                    title="Failed to Reserve Numbers"
                    onClose={() => handleClose(false)}
                    content={
                        <>
                            <p>
                                The following phone number(s) are no longer available because they were
                                reserved by another customer.
                            </p>

                            <ul>
                                {failedTnReserved?.map(num => (
                                    <li key={num}>{num}</li>
                                ))}
                            </ul>
                            <p>
                                Please select alternate number(s) to proceed with your order.
                            </p>
                            <div className="modal-footer border-0">
                                <MDBBtn
                                    color="primary"
                                    onClick={() => handleClose(false)}
                                >
                                    OK
                                </MDBBtn>
                            </div>
                        </>
                    }
                />
            )}
            {SMSenabledphonenumbers == true && (

                <>
                    <MDBModal open={SMSenabledphonenumbers} onClose={() => setSMSenabledphonenumbers(false)} tabIndex='-1' >
                        <MDBModalDialog >
                            <MDBModalContent className="border border-3 border-secondary shadow-4-strong">
                                <MDBModalHeader>
                                    <MDBModalTitle>Request To Enable Phone Numbers</MDBModalTitle>
                                    <MDBBtn className='btn-close' color='none' onClick={SmsReqtoggleOpen}></MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody className="p-0">
                                    <ReqSMSPhNums
                                        stateCode={selectedStateCode}
                                        areaCode={fillActive == "tab1" ? selectAreaCode : selectTollFreeAreaCode}
                                        childClose={SmsReqtoggleOpen}
                                        subChildClose={props.onClose}
                                    />
                                </MDBModalBody>
                            </MDBModalContent>
                        </MDBModalDialog>
                    </MDBModal>


                    {/* <PopupLoader
                        title={"Request To Enable Phone Numbers"}
                        content={
                            <ReqSMSPhNums
                                stateCode={selectedStateCode}
                                areaCode={selectAreaCode}
                                childClose={SmsReqtoggleOpen}
                                subChildClose={props.onClose}
                            />
                        }
                        onClose={SmsReqtoggleOpen}
                    /> */}
                </>
            )

            }

            {
                isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )
            }

            <Tooltip anchorSelect=".removetotip" place="top" className="exampleTooltip" >
                Remove
            </Tooltip>

            <Tooltip anchorSelect=".callerinfo" place="bottom" className="exampleTooltipLight callerinfo w-50" >
                <div style={{ fontSize: '10px' }}>
                    <p className="mb-2">  Caller ID Name Requirements:</p>
                    <ul className="ps-3">
                        <li className="mb-3">Must be between 2-15 characters</li>
                        <li className="mb-3"> Must contain at least 1 letter (Cannot enter a phone number as the Caller ID Name) </li>
                        <li className="mb-3">
                            Special characters allowed: . , & - _ '
                        </li>
                    </ul>

                </div>
            </Tooltip>
        </>
    );

}
